// extracted by mini-css-extract-plugin
export default {"full-width":"ZxxbRv","fullWidth":"U4z_KB","root":"deOLfE","initialized":"P2Jo4h","testNodeWrapper":"ToHKAx","testText":"Z77nYG"};